import React from "react";
import { HeaderConsumer } from "../contexts/HeaderContext";

export default function Header() {
	return (
		<HeaderConsumer>
			{(context) => (
				<div style={{ position: "relative" }}>
					<div className={context.getHeaderClass()}></div>
					<h2 className="header-text display-2">
						{context
							.getHeaderClass()
							.substring(12, context.getHeaderClass().length - 4)
							.replace("-", " ")
							.toUpperCase()}
					</h2>
				</div>
			)}
		</HeaderConsumer>
	);
}